module.exports = __webpack_public_path__ + "img/denmark-cerebrovascular-disease-male.e9da58be.png";